import { render, staticRenderFns } from "./CardStatusChangeRecords.vue?vue&type=template&id=54bdd3d8&scoped=true"
import script from "./CardStatusChangeRecords.vue?vue&type=script&lang=js"
export * from "./CardStatusChangeRecords.vue?vue&type=script&lang=js"
import style0 from "./CardStatusChangeRecords.vue?vue&type=style&index=0&id=54bdd3d8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bdd3d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54bdd3d8')) {
      api.createRecord('54bdd3d8', component.options)
    } else {
      api.reload('54bdd3d8', component.options)
    }
    module.hot.accept("./CardStatusChangeRecords.vue?vue&type=template&id=54bdd3d8&scoped=true", function () {
      api.rerender('54bdd3d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/sj_shopCarCardList/components/CardStatusChangeRecords.vue"
export default component.exports